module.exports = __webpack_public_path__ + "static/media/Jessica Seng.b15fd19e.jpg";